import { render, staticRenderFns } from "./SeriesAdd.vue?vue&type=template&id=3ff97eea"
import script from "./SeriesAdd.vue?vue&type=script&lang=js"
export * from "./SeriesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports